module.exports = __webpack_public_path__ + "media/jason_de_ridder-anders.2dce637f.mp4";